import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=ccb5dd1c&scoped=true&"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=ccb5dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb5dd1c",
  null
  
)

export default component.exports